<template>
  <div>
    <el-form label-position="right">
      <title-and-description :field="field"/>
      <el-row :gutter="30" type="flex">
        <el-col :span="12">
          <el-form-item label="Value">
            <span style="color:red; font-size: 20px;">*</span>   
              <el-time-picker
              :format="'HH:mm:ss'"
              v-model="field.value"
               is-range
              range-separator="To"
              start-placeholder= "Start Time"
              prefix-icon="el-icon-time"
              end-placeholder="End time"
              type="timerange"
              popper-class="my-popover"
              />
       
        <FormError error-key="value" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="form-group">
            <Tag :field="field"/>
          </div>
        </el-col>
      </el-row>
      

    </el-form>
  </div>
</template>

<script>
  
import FormError from "@/components/form/FormError";
import * as moment from "moment"
import Tag from "./Tag"
import TitleAndDescription from "./TitleAndDescription";


export default {
  components: {
    FormError,
    TitleAndDescription,
    Tag

  },
  props: ["field"],
  data() {
    return {
      validations: [],
    };
  },
  methods: {
    onSelectDate() {
      this.field.value = moment(this.date).utc()
      
    }
  },
 
};
</script>

<style lang="scss">
</style>